export const iconFontAwesomeSportsFitnessPersonSwimming = (
	<i className="fa-solid fa-person-swimming"></i>
);
